import React from 'react';
import './Loader.css';

interface LoaderProps {
  fullscreen?: boolean;
}

export const Loader: React.FC<LoaderProps> = ({ fullscreen = false }) => {
  return (
    <div className={`premium-loader-container ${fullscreen ? 'fullscreen' : ''}`}>
      <div className="loader-content">
        <div className="clouds">
          <div className="cloud cloud1" />
          <div className="cloud cloud2" />
          <div className="cloud cloud3" />
          <div className="cloud cloud4" />
          <div className="cloud cloud5" />
        </div>
        <div className="loader">
          <span>
            <span />
            <span />
            <span />
            <span />
          </span>
          <div className="base">
            <span />
            <div className="face" />
          </div>
        </div>
        <div className="longfazers">
          <span />
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
};

export default Loader;
